import { render, staticRenderFns } from "./lampHistory.vue?vue&type=template&id=67941d8c&scoped=true"
import script from "./lampHistory.vue?vue&type=script&lang=js"
export * from "./lampHistory.vue?vue&type=script&lang=js"
import style0 from "./lampHistory.vue?vue&type=style&index=0&id=67941d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67941d8c",
  null
  
)

export default component.exports